import { Alert, Box, Theme, Typography } from "@outschool/backpack";
import { useLocalStorageState } from "@outschool/local-storage";
import { Trans, useTranslation } from "@outschool/localization";
import { joiningAndManagingClassWaitlistsUrl } from "@outschool/routes";
import { ExternalLink } from "@outschool/ui-components-shared";
import React from "react";

import { TabType } from "../../routes/ParentSchedulePage";
import { UpcomingClassesList } from "../UpcomingClassesList";
import { WaitlistedClassesList } from "../WaitlistedClassesList";

export const ParentScheduleMyClassesList = ({
  currentTab = TabType.Enrolled
}) => {
  const { t } = useTranslation(
    "client\\components\\parentSchedule\\ParentScheduleMyClassesList"
  );

  return (
    <Box
      flex
      sx={(theme: Theme) => ({
        flexDirection: "column",
        gap: 16,
        [theme.breakpoints.up("md")]: {
          gap: 24
        }
      })}
    >
      <Typography variant="h3" component="h1">
        {currentTab === TabType.Waitlisted
          ? t("All Waitlisted Classes")
          : t("My Classes")}
      </Typography>

      <UpcomingClassListFilters />
      {currentTab === TabType.Enrolled && (
        <UpcomingClassesList includeNoMeetingsClasses />
      )}
      {currentTab === TabType.Waitlisted && (
        <>
          <HowWaitlistsWork />
          <WaitlistedClassesList />
        </>
      )}
      {/* 
      {currentTab === TabType.Past && <PastClassesList/>}
       */}
    </Box>
  );
};

const UpcomingClassListFilters = () => {
  // TODO: implement filters
  return null;
};

const HowWaitlistsWork = () => {
  const { t } = useTranslation(
    "client\\components\\parentSchedule\\ParentScheduleMyClassesList"
  );
  const [dismissed, setDismissed] = useLocalStorageState(
    "waitlistsBannerDismissed",
    false
  );
  return dismissed ? null : (
    <Alert
      severity="info"
      title={t("How waitlists work on Outschool")}
      onClose={() => setDismissed(true)}
    >
      <Typography>
        <Trans t={t}>
          We will notify you when a seat becomes available for the section(s)
          you’ve waitlisted. Seats are filled on a first-come, first-serve basis
          and you will not be charged until you successfully enroll. Members get
          priority access to classes.{" "}
          <ExternalLink url={joiningAndManagingClassWaitlistsUrl()}>
            Learn more
          </ExternalLink>
        </Trans>
      </Typography>
    </Alert>
  );
};
